import { View } from './view'

export const SignClientLkApplicationScreen = View
